import {
  JobStatus,
  BackupStatus,
  BillingProvider,
  Provider,
  Environment,
  NetworkClassification,
  AccountState,
  AccountStatusReason,
  EksClusterStatus,
  KubeAccessStatus,
  SecurityAssignmentStatus,
  AuditLogAction,
  DynamoDbBillingMode,
  ErrorCode,
  AwsRdsEngine,
  MPAOperationType,
  EncryptionType,
  type InventoryResource,
} from '@repo/api-gw-sdk';
import type { StaticImageData } from 'next/image';

import type { TagStatus } from '@/components/shared/statusTag';

import { backupStatusActions, type ActionsToLevel } from './actions';

import CloudTrail from '../../../public/statics/images/apps/CloudTrail.png';
import CloudWatch from '../../../public/statics/images/apps/CloudWatch.png';
import CosmosDB from '../../../public/statics/images/apps/CosmosDB.png';
import Gmail from '../../../public/statics/images/apps/Gmail.png';
import GoogleDrive from '../../../public/statics/images/apps/Google drive.png';
import ActiveDirectory from '../../../public/statics/images/apps/active-directory.png';
import ActiveMQ from '../../../public/statics/images/apps/activemq.png';
import Aerospike from '../../../public/statics/images/apps/aerospike.png';
import AnsibleTower from '../../../public/statics/images/apps/ansible-tower.png';
import ApacheHTTPServer from '../../../public/statics/images/apps/apache-http.png';
import Spark from '../../../public/statics/images/apps/apache-spark.png';
import ApacheTomcat from '../../../public/statics/images/apps/apache-tomcat.png';
import Aurora from '../../../public/statics/images/apps/aurora.png';
import BigQuery from '../../../public/statics/images/apps/bigquery.png';
import Cassandra from '../../../public/statics/images/apps/cassandra.png';
import Ceph from '../../../public/statics/images/apps/ceph.png';
import ChatGPT from '../../../public/statics/images/apps/chatgpt.png';
import CircleCI from '../../../public/statics/images/apps/circleci-container-runner.png';
import Claude from '../../../public/statics/images/apps/claude.png';
import ClickHouse from '../../../public/statics/images/apps/clickhouse.png';
import CockroachDB from '../../../public/statics/images/apps/cockroachdb.png';
import Confluence from '../../../public/statics/images/apps/confluence.png';
import Cucumber from '../../../public/statics/images/apps/cucumber.png';
import CursorLogo from '../../../public/statics/images/apps/cursor.png';
import DataBricks from '../../../public/statics/images/apps/databricks.png';
import Datadog from '../../../public/statics/images/apps/datadog.png';
import DeepSeek from '../../../public/statics/images/apps/deepseek.png';
import Docker from '../../../public/statics/images/apps/docker.png';
import DRBD from '../../../public/statics/images/apps/drbd.png';
import Drupal from '../../../public/statics/images/apps/drupal.png';
import DynamoDB from '../../../public/statics/images/apps/dynamodb.png';
import Elasticsearch from '../../../public/statics/images/apps/elasticsearch.png';
import EntraId from '../../../public/statics/images/apps/entra-id.svg';
import Firestore from '../../../public/statics/images/apps/firestore.png';
import GcpLogging from '../../../public/statics/images/apps/gcp-logging.png';
import Git from '../../../public/statics/images/apps/git.png';
import GitHubCopilot from '../../../public/statics/images/apps/github-copilot.png';
import GitHubEnterprise from '../../../public/statics/images/apps/github-enterprise.png';
import GoogleWorkspace from '../../../public/statics/images/apps/google-workspace.svg';
import Grafana from '../../../public/statics/images/apps/grafana.png';
import Hadoop from '../../../public/statics/images/apps/hadoop.png';
import Hive from '../../../public/statics/images/apps/hive.png';
import IIS from '../../../public/statics/images/apps/iis.png';
import InfluxDB from '../../../public/statics/images/apps/influxdb.png';
import Jenkins from '../../../public/statics/images/apps/jenkins.png';
import Jira from '../../../public/statics/images/apps/jira.png';
import Joomla from '../../../public/statics/images/apps/joomla.png';
import ApacheKafka from '../../../public/statics/images/apps/kafka.png';
import Kerberos from '../../../public/statics/images/apps/kerberos.png';
import Kibana from '../../../public/statics/images/apps/kibana.png';
import Kubernetes from '../../../public/statics/images/apps/kubernetes.png';
import LlamaCpp from '../../../public/statics/images/apps/llama-cpp.png';
import Logstash from '../../../public/statics/images/apps/logstash.png';
import MariaDB from '../../../public/statics/images/apps/mariadb.png';
import Mattermost from '../../../public/statics/images/apps/mattermost.png';
import Microsoft365 from '../../../public/statics/images/apps/microsoft-365.svg';
import Exchange from '../../../public/statics/images/apps/microsoft-exchange-server.png';
import MicrosoftOneDrive from '../../../public/statics/images/apps/microsoft-onedrive.svg';
import MicrosoftOutlook from '../../../public/statics/images/apps/microsoft-outlook.svg';
import MicrosoftSharePoint from '../../../public/statics/images/apps/microsoft-sharepoint.png';
import MicrosoftTeams from '../../../public/statics/images/apps/microsoft-teams.svg';
import MongoDB from '../../../public/statics/images/apps/mongodb.png';
import MySQL from '../../../public/statics/images/apps/mysql.png';
import Nginx from '../../../public/statics/images/apps/nginx.png';
import OllamaLogo from '../../../public/statics/images/apps/ollama.png';
import OpenClaw from '../../../public/statics/images/apps/openclaw.png';
import OpenCodeLogo from '../../../public/statics/images/apps/opencode.png';
import OracleDatabaseServer from '../../../public/statics/images/apps/oracle.png';
import PagerDuty from '../../../public/statics/images/apps/pagerduty.png';
import PostgreSQL from '../../../public/statics/images/apps/postgres.png';
import PowerBI from '../../../public/statics/images/apps/powerbi.png';
import Rancher from '../../../public/statics/images/apps/rancher.png';
import Redis from '../../../public/statics/images/apps/redis.png';
import SAPApplicationServer from '../../../public/statics/images/apps/sap-application-server.png';
import SAPHana from '../../../public/statics/images/apps/sap-hana.png';
import SAPMaxDB from '../../../public/statics/images/apps/sap-maxdb.png';
import Sentinel from '../../../public/statics/images/apps/sentinel.png';
import SQLServer from '../../../public/statics/images/apps/sql-server.png';
import Tableau from '../../../public/statics/images/apps/tableau.png';
import Typo3 from '../../../public/statics/images/apps/typo3.png';
import Unknown from '../../../public/statics/images/apps/unknown.png';
import VLLMLogo from '../../../public/statics/images/apps/vllm.png';
import Vtiger from '../../../public/statics/images/apps/vtiger.png';
import AWSLogoDark from '../../../public/statics/images/providers/aws-white.png';
import AWSLogo from '../../../public/statics/images/providers/aws.png';
import AzureLogo from '../../../public/statics/images/providers/azure.png';
import GCPLogo from '../../../public/statics/images/providers/gcp.png';
import UnknownLogo from '../../../public/statics/images/providers/unknown.png';

export const ApplicationsLogos: Record<string, StaticImageData> = {
  Gmail,
  GoogleDrive,
  GoogleWorkspace,
  Microsoft365,
  EntraId,
  Datadog,
  CloudTrail,
  CloudWatch,
  Sentinel,
  ClickHouse,
  PowerBI,
  Logstash,
  BigQuery,
  Firestore,
  Elasticsearch,
  Hive,
  Cassandra,
  MongoDB,
  Confluence,
  MySQL,
  'Oracle Database Server': OracleDatabaseServer,
  PostgreSQL,
  Hadoop,
  ActiveMQ,
  Aerospike,
  Redis,
  'Apache Kafka': ApacheKafka,
  'Apache HTTP Server': ApacheHTTPServer,
  'Apache Tomcat': ApacheTomcat,
  CosmosDB,
  CockroachDB,
  DynamoDB,
  Nginx,
  Tableau,
  Grafana,
  Jenkins,
  Kibana,
  Jira,
  DataBricks,
  'SAP Hana': SAPHana,
  'SAP Application Server': SAPApplicationServer,
  'Active Directory': ActiveDirectory,
  'Internet Information Services (IIS)': IIS,
  'Microsoft Exchange Server': Exchange,
  'Microsoft Outlook': MicrosoftOutlook,
  'Microsoft OneDrive': MicrosoftOneDrive,
  'Microsoft Teams': MicrosoftTeams,
  'Microsoft Active Directory Domain Controller': ActiveDirectory,
  Unknown,
  Spark,
  'Microsoft SQL Server': SQLServer,
  MSSQLServer: SQLServer,
  MariaDB: MariaDB,
  Rancher,
  InfluxDB,
  Aurora,
  'Ansible Tower': AnsibleTower,
  Ceph,
  CircleCI,
  'CircleCI Container Runner': CircleCI,
  Drupal,
  Joomla,
  'Microsoft SharePoint': MicrosoftSharePoint,
  PagerDuty,
  Typo3,
  Vtiger,
  Cucumber,
  Docker,
  DRBD,
  Git,
  'GitHub Enterprise': GitHubEnterprise,
  Kerberos,
  Kubernetes,
  Mattermost,
  'SAP MaxDB': SAPMaxDB,
  ChatGPT,
  Claude,
  Cursor: CursorLogo,
  DeepSeek,
  'GitHub Copilot': GitHubCopilot,
  Ollama: OllamaLogo,
  OpenClaw,
  OpenCode: OpenCodeLogo,
  'llama.cpp': LlamaCpp,
  vLLM: VLLMLogo,
};

export const ApplicationsLogosWithAliases: Record<string, StaticImageData> = {
  ...ApplicationsLogos,
  ...Object.fromEntries(
    Object.entries(ApplicationsLogos).map(([key, val]) => [
      key.toLowerCase(),
      val,
    ])
  ),
  'Oracle Database': OracleDatabaseServer,
  Oracle: OracleDatabaseServer,
  WebLogic: OracleDatabaseServer,
  Mongo: MongoDB,
  mongo: MongoDB,
  postgres: PostgreSQL,
  Tomcat: ApacheTomcat,
  IIS,
  'Internet Information Services (IIS)': IIS,
  'SQL Server': SQLServer,
  'sqlserver-se': SQLServer,
  'sqlserver-ee': SQLServer,
  'sqlserver-ex': SQLServer,
  'sqlserver-web': SQLServer,
  mssql: SQLServer,
  Kafka: ApacheKafka,
  // AwsRdsEngine enum values
  [AwsRdsEngine.AWS_RDS_ENGINE_AURORA_MYSQL]: Aurora,
  [AwsRdsEngine.AWS_RDS_ENGINE_AURORA_POSTGRESQL]: PostgreSQL,
  [AwsRdsEngine.AWS_RDS_ENGINE_POSTGRES]: PostgreSQL,
  [AwsRdsEngine.AWS_RDS_ENGINE_MYSQL]: MySQL,
  [AwsRdsEngine.AWS_RDS_ENGINE_SQLSERVER_SE]: SQLServer,
  [AwsRdsEngine.AWS_RDS_ENGINE_SQLSERVER_EE]: SQLServer,
  [AwsRdsEngine.AWS_RDS_ENGINE_SQLSERVER_EX]: SQLServer,
  [AwsRdsEngine.AWS_RDS_ENGINE_SQLSERVER_WEB]: SQLServer,
  [AwsRdsEngine.AWS_RDS_ENGINE_SQLSERVER_DEV_EE]: SQLServer,
  [AwsRdsEngine.AWS_RDS_ENGINE_ORACLE_EE]: OracleDatabaseServer,
  [AwsRdsEngine.AWS_RDS_ENGINE_ORACLE_EE_CDB]: OracleDatabaseServer,
  [AwsRdsEngine.AWS_RDS_ENGINE_ORACLE_SE2]: OracleDatabaseServer,
  [AwsRdsEngine.AWS_RDS_ENGINE_ORACLE_SE2_CDB]: OracleDatabaseServer,
  [AwsRdsEngine.AWS_RDS_ENGINE_ORACLE_SE1]: OracleDatabaseServer,
  [AwsRdsEngine.AWS_RDS_ENGINE_ORACLE_SE]: OracleDatabaseServer,
  CLOUDTRAIL: CloudTrail,
  CLOUDWATCH: CloudWatch,
  GCP_CLOUD_LOGGING: GcpLogging,
  DATADOG: Datadog,
  'Google Drive': GoogleDrive,
};

export const DatabaseEngineAliases: Record<string, string> = {
  'sqlserver-se': 'SQL Server Standard Edition',
  'sqlserver-ee': 'SQL Server Enterprise Edition',
  'sqlserver-ex': 'SQL Server Express Edition',
  'sqlserver-web': 'SQL Server Web Edition',
  'sqlserver-dev-ee': 'SQL Server Developer Edition',
  mssql: 'SQL Server running on VM',
  // AwsRdsEngine enum values
  [AwsRdsEngine.AWS_RDS_ENGINE_AURORA_MYSQL]: 'Aurora MySQL',
  [AwsRdsEngine.AWS_RDS_ENGINE_AURORA_POSTGRESQL]: 'Aurora PostgreSQL',
  [AwsRdsEngine.AWS_RDS_ENGINE_POSTGRES]: 'PostgreSQL',
  [AwsRdsEngine.AWS_RDS_ENGINE_MYSQL]: 'MySQL',
  [AwsRdsEngine.AWS_RDS_ENGINE_SQLSERVER_SE]: 'SQL Server Standard Edition',
  [AwsRdsEngine.AWS_RDS_ENGINE_SQLSERVER_EE]: 'SQL Server Enterprise Edition',
  [AwsRdsEngine.AWS_RDS_ENGINE_SQLSERVER_EX]: 'SQL Server Express Edition',
  [AwsRdsEngine.AWS_RDS_ENGINE_SQLSERVER_WEB]: 'SQL Server Web Edition',
  [AwsRdsEngine.AWS_RDS_ENGINE_SQLSERVER_DEV_EE]:
    'SQL Server Developer Edition',
  [AwsRdsEngine.AWS_RDS_ENGINE_ORACLE_EE]: 'Oracle Enterprise Edition',
  [AwsRdsEngine.AWS_RDS_ENGINE_ORACLE_EE_CDB]: 'Oracle Enterprise Edition CDB',
  [AwsRdsEngine.AWS_RDS_ENGINE_ORACLE_SE2]: 'Oracle Standard Edition 2',
  [AwsRdsEngine.AWS_RDS_ENGINE_ORACLE_SE2_CDB]: 'Oracle Standard Edition 2 CDB',
  [AwsRdsEngine.AWS_RDS_ENGINE_ORACLE_SE1]: 'Oracle Standard Edition 1',
  [AwsRdsEngine.AWS_RDS_ENGINE_ORACLE_SE]: 'Oracle Standard Edition',
};

export const ApplicationNameAliases: Record<string, string> = {
  ...DatabaseEngineAliases,
};

const cloudProviders: Record<
  Provider,
  { logo: StaticImageData; logoDark?: StaticImageData; displayName: string }
> = {
  [Provider.Aws]: {
    displayName: 'AWS',
    logo: AWSLogo,
    logoDark: AWSLogoDark,
  },
  [Provider.Azure]: {
    displayName: 'Azure',
    logo: AzureLogo,
  },
  [Provider.Gcp]: {
    displayName: 'GCP',
    logo: GCPLogo,
  },
  [Provider.MongoAtlas]: {
    displayName: 'MongoDB Atlas',
    logo: MongoDB,
  },
  [Provider.GoogleWorkspace]: {
    displayName: 'Google Workspace',
    logo: GoogleWorkspace,
  },
  [Provider.Microsoft365]: {
    displayName: 'Microsoft 365',
    logo: Microsoft365,
  },
  [Provider.AzureEntraId]: {
    displayName: 'Entra ID',
    logo: ActiveDirectory,
  },
  [Provider.ProviderUnspecified]: {
    displayName: 'Provider Unspecified',
    logo: UnknownLogo,
  },
};

const billingProviders: Record<
  BillingProvider,
  { logo: StaticImageData; logoDark?: StaticImageData; displayName: string }
> = {
  [BillingProvider.BILLING_AWS]: {
    displayName: 'AWS',
    logo: AWSLogo,
    logoDark: AWSLogoDark,
  },
  [BillingProvider.BILLING_AZURE]: {
    displayName: 'Azure',
    logo: AzureLogo,
  },
  [BillingProvider.BILLING_GCP]: {
    displayName: 'GCP',
    logo: GCPLogo,
  },
  [BillingProvider.BILLING_DIRECT]: {
    displayName: 'Eon',
    logo: UnknownLogo,
  },
  [BillingProvider.BILLING_PROVIDER_UNSPECIFIED]: {
    displayName: 'Unknown',
    logo: UnknownLogo,
  },
};

interface ExtraInformationDescription {
  entitySpecifyingField: (entity: InventoryResource) => string | undefined;
  descriptions: Record<string, string>;
}

const backupStatuses: Record<
  BackupStatus,
  {
    icon: string;
    title: string;
    iconColor: string;
    backgroundColor: string;
    description: string;
    fullDescription: string;
    recommendation?: string;
    extraInformationDescription?: ExtraInformationDescription;
    actions: ActionsToLevel;
  }
> = {
  [BackupStatus.Protected]: {
    icon: 'material-symbols-check-circle-outline-rounded',
    title: 'Protected',
    iconColor: 'var(--mui-palette-success-main)',
    backgroundColor: 'var(--mui-palette-success-opacity)',
    description:
      'The resource is continuously backed up by Eon and there are no control violations.',
    fullDescription:
      'This resource is continuously backed up by Eon with no active control violations.',
    actions: backupStatusActions.PROTECTED,
  },
  [BackupStatus.ViolationsDetected]: {
    icon: 'material-symbols-error-outline-rounded',
    title: 'Violations detected',
    iconColor: 'var(--mui-palette-custom-GRADIENT-VIOLATIONS-ICON)',
    backgroundColor: 'var(--mui-palette-custom-GRADIENT-VIOLATIONS)',
    description:
      'Resources that violate a backup control, so they’re not compliant.',
    recommendation:
      'We recommend updating your backup policies to fix the violations.',
    fullDescription:
      "This resource violates a backup control, so it's not compliant. We recommend updating your backup policies to fix the violations.",
    actions: backupStatusActions.VIOLATIONS_DETECTED,
  },
  [BackupStatus.NotBackedUp]: {
    icon: 'material-symbols-disc-full-outline-rounded',
    title: 'Not backed up',
    iconColor: 'var(--mui-palette-error-main)',
    backgroundColor: 'var(--mui-palette-error-opacity)',
    description:
      'No backup policies apply to these resources, and no one has excluded them from backups.',
    recommendation:
      'We recommend updating your backup policies to include the resources.',
    fullDescription:
      'There are no backup policies applied to this resource, and it is not manually excluded from backup. We recommend updating your backup policies to include this resource.',
    actions: backupStatusActions.NOT_BACKED_UP,
  },
  [BackupStatus.AllViolationsMuted]: {
    icon: 'material-symbols-motion-photos-paused-outline-rounded',
    title: 'All violations muted',
    iconColor: 'var(--mui-palette-success-main)',
    backgroundColor: 'var(--mui-palette-success-opacity)',
    description:
      'Resources that violate at least one backup control, but someone muted all notifications.',
    fullDescription:
      'This resource violates at least one backup control, but someone muted all violations.',
    actions: backupStatusActions.ALL_VIOLATIONS_MUTED,
  },
  [BackupStatus.ExcludedFromBackup]: {
    icon: 'material-symbols-hide-source-outline-rounded',
    title: 'Excluded from backup',
    iconColor: 'var(--mui-palette-custom-GREY-01)',
    backgroundColor: 'var(--mui-palette-custom-GREY-OPACITY)',
    description:
      'A team member asked Eon not to back up these resources. They won’t trigger any alerts for backup issues.',
    fullDescription:
      'A team member asked Eon not to back up this resource. It won’t trigger any alerts for backup issues.',
    actions: backupStatusActions.EXCLUDED_FROM_BACKUP,
  },
  [BackupStatus.GenericBackups]: {
    icon: 'ic-outline-brightness-1',
    title: 'Backed up by others',
    iconColor: 'var(--mui-palette-warning-main)',
    backgroundColor: 'var(--mui-palette-warning-opacity)',
    description:
      'Resources that are backed up, but not by Eon, so you won’t be able to explore the resource files and databases, or restore granular data.',
    recommendation:
      'We recommend updating your policies to back up these resources with Eon.',
    fullDescription:
      "This resource backed up, but not by Eon. Eon can't be used to restore data. We recommend updating your policies to back up with Eon.",
    actions: backupStatusActions.GENERIC_BACKUPS,
  },
  [BackupStatus.InitialClassification]: {
    icon: 'material-symbols-avg-pace-rounded',
    title: 'Initial classification',
    iconColor: 'var(--mui-palette-info-main)',
    backgroundColor: 'var(--mui-palette-info-opacity)',
    description:
      'Resources that were recently discovered and are being scanned by Eon for the first time. Their statuses will be updated after the scan is done.',
    fullDescription:
      'This resource recently discovered and currently being scanned by Eon for the first time. The status will be updated after the scan is done.',
    actions: backupStatusActions.INITIAL_CLASSIFICATION,
  },
  [BackupStatus.Terminated]: {
    icon: 'material-symbols-do-not-disturb-on-outline-rounded',
    title: 'Terminated',
    iconColor: 'var(--mui-palette-custom-GREY-01)',
    backgroundColor: 'var(--mui-palette-custom-GREY-OPACITY)',
    description:
      'Resources that were terminated in your source account. They may have Eon snapshots or cloud recovery points you can explore and restore.',
    fullDescription:
      'This resource was terminated in your source account. It may have Eon snapshots or cloud recovery points you can explore and restore.',
    actions: backupStatusActions.TERMINATED,
  },
  [BackupStatus.Disconnected]: {
    icon: 'material-symbols-error-med-outline-rounded',
    title: 'Disconnected',
    iconColor: 'var(--mui-palette-custom-GREY-01)',
    backgroundColor: 'var(--mui-palette-custom-GREY-OPACITY)',
    description: `Resources from a source account that's no longer connected to Eon. They still have Eon snapshots and you can explore and restore.`,
    fullDescription: `This resource's source account was disconnected from Eon. It still has Eon snapshots you can explore and restore.`,
    actions: backupStatusActions.DISCONNECTED,
  },
  [BackupStatus.Dlsg]: {
    icon: 'material-symbols-door-open-outline-rounded',
    // icon: 'material-symbols-sensors-rounded',
    title: 'Storage gateway',
    iconColor: 'var(--mui-palette-success-main)',
    backgroundColor: 'var(--mui-palette-success-opacity)',
    description:
      'The resource is available in the gateway. You can access its objects.',
    fullDescription:
      'This resource is available in the gateway. You can access its objects.',
    actions: backupStatusActions.DLSG,
  },
  [BackupStatus.BackupPostureStatusUnspecified]: {
    icon: '',
    title: '',
    iconColor: '',
    backgroundColor: '',
    description: '',
    fullDescription: '',
    actions: backupStatusActions.BACKUP_POSTURE_STATUS_UNSPECIFIED,
  },
  [BackupStatus.Unsupported]: {
    icon: 'material-symbols-cancel-outline',
    title: 'Unsupported',
    iconColor: 'var(--mui-palette-custom-GREY-01)',
    backgroundColor: 'var(--mui-palette-custom-GREY-OPACITY)',
    description: `Resources that aren't supported for backup.`,
    fullDescription: `This resource isn't supported for backup by Eon.`,
    actions: backupStatusActions.UNSUPPORTED,
  },
  [BackupStatus.ActionRequired]: {
    icon: 'material-symbols-ads-click',
    title: 'Action required',
    iconColor: 'var(--mui-palette-custom-GRADIENT-VIOLATIONS-ICON)',
    backgroundColor: 'var(--mui-palette-custom-GRADIENT-VIOLATIONS)',
    description: `Additional actions in your cloud account are required to enable all defined backups.`,
    fullDescription: `This resource requires an action to be taken before Eon can start its backup.`,
    // Reason copy comes from statusProperties.blockers (server-resolved, like Unsupported), so no per-reason descriptions map is needed here.
    actions: backupStatusActions.ACTION_REQUIRED,
  },
  [BackupStatus.LimitExceeded]: {
    icon: 'material-symbols-readiness-score-outline',
    title: 'Out of scope',
    iconColor: 'var(--mui-palette-custom-GREY-01)',
    backgroundColor: 'var(--mui-palette-custom-GREY-OPACITY)',
    description: `This resource is out of scope because it exceeds one or more configured limits, such as resource size, object count, or the maximum number of resources for its type.`,
    fullDescription: `This resource is out of scope because it exceeds one or more configured limits, such as resource size, object count, or the maximum number of resources for its type.`,
    extraInformationDescription: {
      entitySpecifyingField: (entity) => entity.quota?.quotaStatus,
      descriptions: {
        SIZE_EXCEEDED: `Backup is disabled because this resource is over the maximum size limit. Contact Eon Support to increase your limit.`,
        OBJECT_COUNT_EXCEEDED: `Backup is disabled because this resource is over the maximum object count limit. Contact Eon Support to increase your limit.`,
        MAX_RESOURCES_EXCEEDED: `Backup is disabled because you've reached the maximum number of resources for this type. To enable this resource in backup, first exclude another resource.`,
      },
    },
    actions: backupStatusActions.LIMIT_EXCEEDED,
  },
};

export const ControlsSeverity: Record<
  string,
  { color: string; title: string }
> = {
  high: {
    title: 'High',
    color: 'var(--mui-palette-error-main)',
  },
  medium: {
    title: 'Medium',
    color: 'var(--mui-palette-custom-ORANGE-01)',
  },
  low: {
    title: 'Low',
    color: 'var(--mui-palette-warning-main)',
  },
  muted: {
    title: 'Muted',
    color: 'var(--mui-palette-divider)',
  },
};

const environments: Record<
  Environment,
  { title: string; description: string }
> = {
  [Environment.Prod]: {
    title: 'Production',
    description:
      'The resource is part of a customer-facing or external-facing production environment.',
  },
  [Environment.ProdInternal]: {
    title: 'Internal production',
    description:
      'The resource is part of an internal-only production environment, such as an EC2 instance running Jira Enterprise.',
  },
  [Environment.Stage]: {
    title: 'Non-production',
    description: `The resource isn't part of a production environment—for example, staging or dev.`,
  },
  [Environment.EnvironmentUnspecified]: {
    title: 'Unspecified',
    description:
      'The resource is part of an environment that is not specified.',
  },
};

const networkClassifications: Record<
  NetworkClassification,
  { title: string; description: string }
> = {
  [NetworkClassification.NETWORK_CLASSIFICATION_PUBLICLY_EXPOSED]: {
    title: 'Publicly exposed',
    description:
      'The resource accepts traffic from any source on the public internet.',
  },
  [NetworkClassification.NETWORK_CLASSIFICATION_RESTRICTED_EXTERNAL]: {
    title: 'Restricted external',
    description:
      'The resource accepts external traffic, but only from specific addresses or accounts.',
  },
  [NetworkClassification.NETWORK_CLASSIFICATION_CORPORATE_NETWORK_CONNECTED]: {
    title: 'Corporate network connected',
    description:
      'The resource is reachable from the corporate network (for example via VPN, peering, or a transit gateway), not the public internet.',
  },
  [NetworkClassification.NETWORK_CLASSIFICATION_INTERNAL]: {
    title: 'Isolated',
    description: `The resource isn't reachable from outside its cloud-internal network.`,
  },
  [NetworkClassification.NETWORK_CLASSIFICATION_UNKNOWN]: {
    title: 'Unknown',
    description:
      'Eon could not determine the network exposure of this resource from the available data.',
  },
  [NetworkClassification.NETWORK_CLASSIFICATION_UNSPECIFIED]: {
    title: 'Unspecified',
    description: 'The resource has not been classified yet.',
  },
};

const jobStatuses: Record<
  JobStatus,
  {
    title: string;
    iconColor: string;
    backgroundColor: string;
    icon: string;
    staticIcon?: string;
  }
> = {
  [JobStatus.JOB_COMPLETED]: {
    title: 'Complete',
    iconColor: 'var(--mui-palette-success-main)',
    backgroundColor: 'var(--mui-palette-success-opacity)',
    icon: 'material-symbols-check-circle-outline-rounded',
  },
  [JobStatus.JOB_PARTIAL]: {
    title: 'Partially complete',
    iconColor: 'var(--mui-palette-success-main)',
    backgroundColor: 'var(--mui-palette-success-opacity)',
    icon: 'material-symbols-running-with-errors-rounded',
  },
  [JobStatus.JOB_RUNNING]: {
    title: 'Running',
    iconColor: 'var(--mui-palette-info-main)',
    backgroundColor: 'var(--mui-palette-info-opacity)',
    icon: 'line-md-loading-loop',
    staticIcon: 'material-symbols-progress-activity',
  },
  [JobStatus.JOB_PENDING]: {
    title: 'Pending',
    iconColor: 'var(--mui-palette-custom-GREY-01)',
    backgroundColor: 'var(--mui-palette-custom-GREY-OPACITY)',
    icon: 'material-symbols-schedule-outline',
  },
  [JobStatus.JOB_CANCELED]: {
    title: 'Canceled',
    iconColor: 'var(--mui-palette-custom-GREY-01)',
    backgroundColor: 'var(--mui-palette-custom-GREY-OPACITY)',
    icon: 'material-symbols-cancel-outline',
  },
  [JobStatus.JOB_SKIPPED]: {
    title: 'Skipped',
    iconColor: 'var(--mui-palette-warning-main)',
    backgroundColor: 'var(--mui-palette-warning-opacity)',
    icon: 'material-symbols-next-plan-outline',
  },
  [JobStatus.JOB_REJECTED]: {
    title: 'Rejected',
    iconColor: 'var(--mui-palette-custom-GRADIENT-VIOLATIONS-ICON)',
    backgroundColor: 'var(--mui-palette-custom-GRADIENT-VIOLATIONS)',
    icon: 'material-symbols-block-outline',
  },
  [JobStatus.JOB_FAILED]: {
    title: 'Failed',
    iconColor: 'var(--mui-palette-error-main)',
    backgroundColor: 'var(--mui-palette-error-opacity)',
    icon: 'material-symbols-cancel-outline',
  },
  [JobStatus.JOB_UNSPECIFIED]: {
    title: 'Unspecified',
    iconColor: 'var(--mui-palette-custom-GREY-01)',
    backgroundColor: 'var(--mui-palette-custom-GREY-OPACITY)',
    icon: '',
  },
};

export const PiiStrings: Record<string, string> = {
  ADDRESS: 'Address',
  NAME: 'Name',
  AGE: 'Age',
  DATE_OF_BIRTH: 'Date of birth',
  GENDER: 'Gender',
  USERNAME: 'Username',
  PASSWORD: 'Password',
  IMEI: 'IMEI',
  VEHICLE_IDENTIFICATION_NUMBER: 'Vehicle ID number (VIN)',

  PHONE_NUMBER: 'Phone number',
  EMAIL_ADDRESS: 'Email address',
  IP_ADDRESS: 'IP address',
  MAC_ADDRESS: 'MAC address',

  US_ZIP_CODE: 'US postal code',
  US_SOCIAL_SECURITY_NUMBER: 'US Social Security number',
  US_PASSPORT_NUMBER: 'US passport number',
  US_DRIVER_LICENSE: "US driver's license",
  US_ITIN: 'US individual taxpayer ID number',
  US_VEHICLE_IDENTIFICATION_NUMBER: 'US vehicle ID number',
  US_MEDICARE_BENEFICIARY_ID_NUMBER: 'US Medicare beneficiary ID number',
  US_EMPLOYER_IDENTIFICATION_NUMBER: 'US employer ID number',

  US_PTIN: 'US preparer tax ID number',

  CA_PASSPORT_NUMBER: 'Canadian passport number',
  CA_DRIVER_LICENSE: "Canadian driver's license",
  CA_SOCIAL_INSURANCE_NUMBER: 'Canadian social insurance number',
  CA_HEALTH_SERVICE_NUMBER: 'Canadian health service number',

  CREDIT_DEBIT_CARD_NUMBER: 'Credit card number',
  CREDIT_DEBIT_CARD_EXPIRY: 'Credit card expiration date',
  CREDIT_DEBIT_CARD_CVV: 'Credit card CVV or other security code',
  CRYPTO_CURRENCY_ADDRESS: 'Crypto wallet address',
  IBAN_CODE: 'International bank account number',
  SWIFT_CODE: 'SWIFT code',
  BANK_ACCOUNT_NUMBER: 'Bank account number',

  US_BANK_ROUTING_MICR: 'US bank routing number',

  // PHI
  ICD_10_CODE: 'Medical diagnosis',
  CPT_CODE: 'Medical procedural code',
  US_NATIONAL_PROVIDER_IDENTIFIER: 'US national provider ID (NPI)',
  MEDICAL_RECORD: 'Medical record',

  // CREDENTIALS
  AWS_ACCESS_KEY: 'AWS access key',
  CLOUD_API_KEY: 'Cloud API key',
  VCS_TOKEN: 'Source control token',
  SAAS_API_TOKEN: 'SaaS API token',
  AI_API_TOKEN: 'AI API token',
  PRIVATE_KEY: 'Private key',
  AUTH_TOKEN: 'Auth token',
  DATABASE_CONNECTION_STRING: 'Database connection string',
  KUBERNETES_SECRET: 'Kubernetes secret',
  ENV_FILE_SECRET: 'Env file secret',

  // TODO(Benji) this mapping needs to be dynamic and come from the backend since the list depends on what the customer has configured
  PARENTAL_CONSENT_FORM: 'Parental consent form',
};

export const PiiStringTypes: Record<string, string> = {
  ADDRESS: 'PII',
  NAME: 'PII',
  AGE: 'PII',
  DATE_OF_BIRTH: 'PII',
  GENDER: 'PII',
  USERNAME: 'PII',
  PASSWORD: 'PII',
  IMEI: 'PII',
  VEHICLE_IDENTIFICATION_NUMBER: 'PII',

  PHONE_NUMBER: 'PII',
  EMAIL_ADDRESS: 'PII',
  IP_ADDRESS: 'PII',
  MAC_ADDRESS: 'PII',

  US_ZIP_CODE: 'PII',
  US_SOCIAL_SECURITY_NUMBER: 'PII',
  US_PASSPORT_NUMBER: 'PII',
  US_DRIVER_LICENSE: 'PII',
  US_ITIN: 'PII',
  US_VEHICLE_IDENTIFICATION_NUMBER: 'PII',
  US_MEDICARE_BENEFICIARY_ID_NUMBER: 'PHI',
  US_EMPLOYER_IDENTIFICATION_NUMBER: 'PII',
  PARENTAL_CONSENT_FORM: 'PII',

  US_PTIN: 'PII',

  CA_PASSPORT_NUMBER: 'PII',
  CA_DRIVER_LICENSE: 'PII',
  CA_SOCIAL_INSURANCE_NUMBER: 'PII',
  CA_HEALTH_SERVICE_NUMBER: 'PHI',

  CREDIT_DEBIT_CARD_NUMBER: 'FI',
  CREDIT_DEBIT_CARD_EXPIRY: 'FI',
  CREDIT_DEBIT_CARD_CVV: 'FI',
  CRYPTO_CURRENCY_ADDRESS: 'FI',
  IBAN_CODE: 'FI',
  SWIFT_CODE: 'FI',
  BANK_ACCOUNT_NUMBER: 'FI',

  US_BANK_ROUTING_MICR: 'FI',

  // PHI
  ICD_10_CODE: 'PHI',
  CPT_CODE: 'PHI',
  US_NATIONAL_PROVIDER_IDENTIFIER: 'PHI',
  MEDICAL_RECORD: 'PHI',

  // CREDENTIALS
  AWS_ACCESS_KEY: 'CREDENTIALS',
  CLOUD_API_KEY: 'CREDENTIALS',
  VCS_TOKEN: 'CREDENTIALS',
  SAAS_API_TOKEN: 'CREDENTIALS',
  AI_API_TOKEN: 'CREDENTIALS',
  PRIVATE_KEY: 'CREDENTIALS',
  AUTH_TOKEN: 'CREDENTIALS',
  DATABASE_CONNECTION_STRING: 'CREDENTIALS',
  KUBERNETES_SECRET: 'CREDENTIALS',
  ENV_FILE_SECRET: 'CREDENTIALS',
};

const accountStatuses: Record<
  AccountState,
  {
    title: string;
    icon: string;
    tagStatus: TagStatus;
  }
> = {
  [AccountState.ACCOUNT_STATE_CONNECTED]: {
    title: 'Connected',
    tagStatus: 'active',
    icon: 'material-symbols-check-circle-outline-rounded',
  },
  [AccountState.ACCOUNT_STATE_DISCONNECTED]: {
    title: 'Disconnected',
    tagStatus: 'inactive',
    icon: 'material-symbols-error-med-outline-rounded',
  },
  [AccountState.ACCOUNT_STATE_INSUFFICIENT_PERMISSIONS]: {
    title: 'Permissions required',
    tagStatus: 'pending',
    icon: 'material-symbols-ads-click',
  },
  [AccountState.ACCOUNT_STATE_NOT_READY]: {
    title: 'Setup required',
    tagStatus: 'pending',
    icon: 'material-symbols-info-outline',
  },
  [AccountState.ACCOUNT_STATE_UNSPECIFIED]: {
    title: '',
    icon: '',
    tagStatus: 'error',
  },
};

const eksClusterStatuses: Record<EksClusterStatus, { title: string }> = {
  [EksClusterStatus.EKS_CLUSTER_STATUS_ACTIVE]: {
    title: 'Active',
  },
  [EksClusterStatus.EKS_CLUSTER_STATUS_CREATING]: {
    title: 'Creating',
  },
  [EksClusterStatus.EKS_CLUSTER_STATUS_FAILED]: {
    title: 'Failed',
  },
  [EksClusterStatus.EKS_CLUSTER_STATUS_DELETING]: {
    title: 'Deleting',
  },
  [EksClusterStatus.EKS_CLUSTER_STATUS_UPDATING]: {
    title: 'Updating',
  },
  [EksClusterStatus.EKS_CLUSTER_STATUS_PENDING]: {
    title: 'Pending',
  },
  [EksClusterStatus.EKS_CLUSTER_STATUS_UNSPECIFIED]: {
    title: '',
  },
};

const kubeAccessStatuses: Record<
  KubeAccessStatus,
  { title: string; icon: string; tagStatus: TagStatus }
> = {
  [KubeAccessStatus.KUBE_ACCESS_STATUS_FULL_ACCESS]: {
    title: 'Full access',
    tagStatus: 'active',
    icon: 'material-symbols-check-circle-outline-rounded',
  },
  [KubeAccessStatus.KUBE_ACCESS_STATUS_INSUFFICIENT_PERMISSIONS]: {
    title: 'Insufficient permissions',
    tagStatus: 'pending',
    icon: 'material-symbols-ads-click',
  },
  [KubeAccessStatus.KUBE_ACCESS_STATUS_NO_NETWORK_ACCESS]: {
    title: 'No network access',
    tagStatus: 'pending',
    icon: 'material-symbols-info-outline',
  },
  [KubeAccessStatus.KUBE_ACCESS_STATUS_PARTIAL_ACCESS]: {
    title: 'Partial access',
    tagStatus: 'pending',
    icon: 'material-symbols-info-outline',
  },
  [KubeAccessStatus.KUBE_ACCESS_STATUS_IAM_ROLE_MISCONFIGURED]: {
    title: 'IAM role misconfigured',
    tagStatus: 'pending',
    icon: 'material-symbols-ads-click',
  },
  [KubeAccessStatus.KUBE_ACCESS_STATUS_CONFIGMAP_ONLY_ACCESS]: {
    title: 'Action required',
    tagStatus: 'pending',
    icon: 'material-symbols-ads-click',
  },
  [KubeAccessStatus.KUBE_ACCESS_STATUS_ACCESS_DENIED_BY_POLICY]: {
    title: 'Action required',
    tagStatus: 'pending',
    icon: 'material-symbols-ads-click',
  },
  [KubeAccessStatus.KUBE_ACCESS_STATUS_UNSPECIFIED]: {
    title: '',
    icon: '',
    tagStatus: 'error',
  },
};

export const KubeAccessStatuses = Object.fromEntries(
  Object.entries(kubeAccessStatuses)
);
export const EksClusterStatuses = Object.fromEntries(
  Object.entries(eksClusterStatuses)
);
export const AccountStatuses = Object.fromEntries(
  Object.entries(accountStatuses)
);

export const statusReasonTooltips: Partial<
  Record<AccountStatusReason, string>
> = {
  [AccountStatusReason.ACCOUNT_STATUS_REASON_MISSING_INTERNAL_RESOURCE_GROUP]:
    'Eon couldn’t create the resource group needed to back up this subscription.',
};
export const Environments = Object.fromEntries(
  Object.entries(environments).filter(
    ([key]) => key !== Environment.EnvironmentUnspecified
  )
);

export const NetworkClassifications = Object.fromEntries(
  Object.entries(networkClassifications).filter(
    ([key]) =>
      key !== NetworkClassification.NETWORK_CLASSIFICATION_UNSPECIFIED &&
      key !== NetworkClassification.NETWORK_CLASSIFICATION_UNKNOWN
  )
);

export const SensitivityLevels: Record<
  string,
  { title: string; description: string }
> = {
  PUBLIC: {
    title: 'Public',
    description: `The resource is labeled as public, or no sensitive data was detected on it.`,
  },
  INTERNAL: {
    title: 'Internal',
    description:
      'The resource holds data meant for internal use only, with limited impact if it is exposed.',
  },
  CONFIDENTIAL: {
    title: 'Confidential',
    description:
      'The resource holds personal or financial data, such as names, contact details, or payment data.',
  },
  HIGH_RISK_CONFIDENTIAL: {
    title: 'High risk confidential',
    description:
      'The resource holds highly regulated or high-impact data, such as health records, government IDs, or credentials.',
  },
};
export const EncryptionTypes: Record<string, { title: string }> = {
  [EncryptionType.ENCRYPTION_TYPE_UNENCRYPTED]: { title: 'Unencrypted' },
  [EncryptionType.ENCRYPTION_TYPE_PROVIDER_MANAGED_KEY]: {
    title: 'Provider-managed keys',
  },
  [EncryptionType.ENCRYPTION_TYPE_CUSTOMER_MANAGED_KEY]: {
    title: 'Customer-managed keys',
  },
};
export const BackupStatuses = Object.fromEntries(
  Object.entries(backupStatuses)
);
export const CloudProviders = Object.fromEntries(
  Object.entries(cloudProviders)
);
const BillingProviders = Object.fromEntries(Object.entries(billingProviders));
export function getBillingProviderLabel(bp: BillingProvider): string {
  const name = BillingProviders[bp]?.displayName ?? bp;
  if (bp === BillingProvider.BILLING_DIRECT) {
    return name;
  }
  return `${name} Marketplace`;
}
export const JobStatuses = Object.fromEntries(Object.entries(jobStatuses));

const errorCodes: Record<ErrorCode, { title: string }> = {
  [ErrorCode.InternalJobError]: {
    title: 'Internal job error',
  },
  [ErrorCode.JobCanceledError]: {
    title: 'Job canceled',
  },
  [ErrorCode.CloudOperationFailed]: {
    title: 'Cloud account operation failed',
  },
  [ErrorCode.FailedToGetResourceInformation]: {
    title: 'Failed to get resource information',
  },
  [ErrorCode.ResourceIsTerminated]: {
    title: 'Resource is terminated',
  },
  [ErrorCode.InvalidResourceState]: {
    title: 'Invalid resource state',
  },
  [ErrorCode.InvalidResourceConfiguration]: {
    title: 'Invalid resource configuration',
  },
  [ErrorCode.ResourceConflict]: {
    title: 'Resource conflict',
  },
  [ErrorCode.UnsupportedOperationOnResource]: {
    title: 'Unsupported operation on resource',
  },
  [ErrorCode.FailedToCreateResource]: {
    title: 'Failed to create resource',
  },
  [ErrorCode.FailedToStartResource]: {
    title: 'Failed to start resource',
  },
  [ErrorCode.FailedToStopResource]: {
    title: 'Failed to stop resource',
  },
  [ErrorCode.FailedToGetStorageInformation]: {
    title: 'Failed to get storage information',
  },
  [ErrorCode.FailedToCreateStorage]: {
    title: 'Failed to create storage',
  },
  [ErrorCode.FailedToDeleteStorage]: {
    title: 'Failed to delete storage',
  },
  [ErrorCode.FailedToAttachStorage]: {
    title: 'Failed to attach storage',
  },
  [ErrorCode.FailedToDetachStorage]: {
    title: 'Failed to detach storage',
  },
  [ErrorCode.FailedToCreateImage]: {
    title: 'Failed to create image',
  },
  [ErrorCode.FailedToGetSnapshotInformation]: {
    title: 'Failed to get snapshot information',
  },
  [ErrorCode.FailedToTakeSnapshot]: {
    title: 'Failed to take snapshot',
  },
  [ErrorCode.FailedToUseSnapshot]: {
    title: 'Failed to use snapshot',
  },
  [ErrorCode.FailedToDeleteSnapshot]: {
    title: 'Failed to delete snapshot',
  },
  [ErrorCode.SnapshotQuotaExceeded]: {
    title: 'Snapshot quota exceeded',
  },
  [ErrorCode.ResourceUsageQuotaExceeded]: {
    title: 'Resource usage quota exceeded',
  },
  [ErrorCode.AuthenticationFailure]: {
    title: 'Authentication failure',
  },
  [ErrorCode.InvalidAccountConfiguration]: {
    title: 'Invalid account configuration',
  },
  [ErrorCode.InvalidVaultConfiguration]: {
    title: 'Invalid vault configuration',
  },
  [ErrorCode.InvalidInputParameters]: {
    title: 'Invalid input parameters',
  },
  [ErrorCode.TooManyRequests]: {
    title: 'Too many requests',
  },
  [ErrorCode.BackupConflict]: {
    title: 'Backup conflict',
  },
  [ErrorCode.ClassificationConflict]: {
    title: 'Classification conflict',
  },
  [ErrorCode.FailedToRunQuery]: {
    title: 'Failed to run query',
  },
  [ErrorCode.OperationDeniedByConfiguration]: {
    title: 'Operation denied by configuration',
  },
  [ErrorCode.InsufficientEncryptionPermissions]: {
    title: 'Insufficient encryption permissions',
  },
};

export const ErrorCodes = Object.fromEntries(Object.entries(errorCodes));

const securityStatuses: Record<SecurityAssignmentStatus, { name: string }> = {
  [SecurityAssignmentStatus.SECURITY_ASSIGNED]: {
    name: 'Assigned',
  },
  [SecurityAssignmentStatus.SECURITY_NOT_ASSIGNED]: {
    name: 'Not assigned',
  },
  [SecurityAssignmentStatus.SECURITY_EXCLUDED]: {
    name: 'Excluded',
  },
  [SecurityAssignmentStatus.SECURITY_UNSUPPORTED]: {
    name: 'Unsupported',
  },
  [SecurityAssignmentStatus.SECURITY_UNSPECIFIED]: {
    name: 'Unspecified',
  },
};

export const SecurityStatuses = Object.fromEntries(
  Object.entries(securityStatuses)
);

const auditLogActions: Record<AuditLogAction, { name: string }> = {
  [AuditLogAction.Create]: {
    name: 'Create',
  },
  [AuditLogAction.Update]: {
    name: 'Update',
  },
  [AuditLogAction.Delete]: {
    name: 'Delete',
  },
  [AuditLogAction.Trigger]: {
    name: 'Trigger',
  },
  [AuditLogAction.Read]: {
    name: 'Read',
  },
  [AuditLogAction.Auth]: {
    name: 'Auth',
  },
  [AuditLogAction.Export]: {
    name: 'Export',
  },
  [AuditLogAction.AuditLogActionUnspecified]: {
    name: 'Unknown',
  },
};

export const AuditLogActions = Object.fromEntries(
  Object.entries(auditLogActions)
);

export const SupportedEntityTypes = [
  'cloud_resource',
  'backup_policy',
  'vault',
  'control',
  'role',
  'notification_policy',
  'user',
  'restore_cloud_account',
  'source_cloud_account',
  'scanning_cloud_account',
  'vault_cloud_account',
  'account',
  'restore_template',
];

const dynamoDbBillingModes: Record<DynamoDbBillingMode, { name: string }> = {
  [DynamoDbBillingMode.DYNAMODB_BILLING_MODE_PAY_PER_REQUEST]: {
    name: 'On-demand',
  },
  [DynamoDbBillingMode.DYNAMODB_BILLING_MODE_PROVISIONED]: {
    name: 'Provisioned',
  },
  [DynamoDbBillingMode.DYNAMODB_BILLING_MODE_UNSPECIFIED]: {
    name: '',
  },
};

export const DynamoDbBillingModes = Object.fromEntries(
  Object.entries(dynamoDbBillingModes)
);

const mpaOperations: Record<MPAOperationType, { name: string }> = {
  [MPAOperationType.MPA_OPERATION_TYPE_UNSPECIFIED]: {
    name: '',
  },
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_CREATE_BACKUP_POLICY]: {
    name: 'Create backup policy',
  },
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_DELETE_BACKUP_POLICY]: {
    name: 'Delete backup policy',
  },
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_RESTORE_RESOURCE]: {
    name: 'Restore resource',
  },
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_UPDATE_BACKUP_POLICY]: {
    name: 'Update backup policy',
  },
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_ADD_RESTORE_ACCOUNT]: {
    name: 'Connect restore account',
  },
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_REMOVE_SNAPSHOT_HOLD]: {
    name: 'Remove snapshot hold',
  },
};

export const MpaOperations = Object.fromEntries(Object.entries(mpaOperations));
